module.exports = __webpack_public_path__ + "media/images/pages/fig_gourmet_01-e9589f9f2bc481aa30cc8482d6f261fb.png";